/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getIconPath } from '@tcp/core/src/utils/utils';
import Notification from '@tcp/core/src/components/common/molecules/Notification';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Button from '@tcp/core/src/components/common/atoms/Button/views/Button.jsx';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy/views/BodyCopy.jsx';
import Image from '@tcp/core/src/components/common/atoms/Image/views/Image.jsx';
import ErrorMessage from '@tcp/core/src/components/features/CnC/common/molecules/ErrorMessage/views/ErrorMessage.view.jsx';
import styles from '@tcp/core/src/components/common/molecules/NewCouponCard/styles/NewCouponCard.style.js';
import {
  COUPON_REDEMPTION_TYPE,
  COUPON_STATUS,
} from '@tcp/core/src/services/abstractors/CnC/CartItemTile.js';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty.js';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblDetails,
} from '@tcp/core/src/utils/labels/globalGeneric.labels.js';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
} from '@tcp/core/src/utils/labels/globalActions.labels.js';
import CouponCardLabels, {
  ACCOUNT_LABELS,
  CHECKOUT_LABELS,
  GLOBAL_LABELS,
} from '@tcp/core/src/components/common/molecules/CouponCard/labels/CouponCard.labels.js';
import NewCouponCardConstant from '@tcp/core/src/components/common/molecules/NewCouponCard/views/NewCouponCard.constant.js';

const NewCouponCard = (props) => {
  const {
    className,
    coupon,
    handleErrorCoupon,
    ledgerSummaryData,
    autoApplyPerkCouponType,
    onApply,
    isFetching,
    isAccountDrawer,
    isPlacePerkEnabled,
    isPlacePerks,
    isBonusPointDayEnabled,
    setBonusPointDayCouponIndexAction,
    fromIsApplyAction,
    multiAddCouponLoader,
    onRemove,
    couponDetailClick,
    couponsOnHold,
    spc,
    spcBag,
    isCarouselView,
    couponOnHoldNewDesign,
  } = props;

  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, CouponCardLabels);
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, CouponCardLabels);
  const accountLabel = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, CouponCardLabels);

  useEffect(() => {
    if (coupon && coupon?.error) {
      handleErrorCoupon(coupon);
    }
  }, [coupon?.error]);

  const getCouponLabelValue = ({ errorBonusPoints }) => {
    let value = '';
    if (coupon?.isExpired) {
      value = renderLabel(checkoutLabels.billing?.lbl_expired, 'lbl_expired');
    } else if (coupon?.isExpiring) {
      value = renderLabel(
        checkoutLabels.bagPage?.lbl_couponlist_expiring,
        'lbl_couponlist_expiring'
      );
    } else if (errorBonusPoints && isBonusPointDayEnabled) {
      value = renderLabel(
        accountLabel.accountOverview?.lbl_bonus_points_error,
        'lbl_bonus_points_error'
      );
    }
    return value;
  };

  const getCouponExpiringStatus = (errorBonusPoints) => {
    const {
      subTotal = 0,
      couponsTotal = 0,
      savingsTotal = 0,
      giftCardsItemsTotalPrice = 0,
      giftCardsTotal = 0,
      itemsCount = 0,
    } = ledgerSummaryData || {};
    const estimatedTotal = itemsCount
      ? subTotal - couponsTotal - savingsTotal - giftCardsItemsTotalPrice - giftCardsTotal
      : 0;

    let value = getCouponLabelValue({ errorBonusPoints });

    if (couponOnHoldNewDesign && coupon?.isOnHold === NewCouponCardConstant.TRUE) {
      value =
        coupon?.originalOfferType === NewCouponCardConstant.PLCB ||
        coupon?.originalOfferType === NewCouponCardConstant.PLCC_USER
          ? renderLabel(checkoutLabels.bagPage?.lbl_coupon_onhold_error, 'lbl_coupon_onhold_error')
          : renderLabel(
              checkoutLabels.bagPage?.lbl_coupon_generic_onhold_msg,
              'lbl_coupon_generic_onhold_msg'
            );
      if (
        coupon?.couponValue &&
        (coupon?.originalOfferType === COUPON_REDEMPTION_TYPE?.LOYALTY ||
          coupon?.originalOfferType === COUPON_REDEMPTION_TYPE?.PERKS_LOYALTY)
      ) {
        const thresholdValue = Number(coupon?.couponValue - estimatedTotal) || 0;
        value =
          renderLabel(
            checkoutLabels.bagPage?.lbl_coupon_threshold_onhold_msg,
            'lbl_coupon_threshold_onhold_msg'
          )?.replace('XX', Math.abs(thresholdValue)?.toFixed(2)) || '';
      }
    }
    if (!coupon?.isStarted) {
      value = getDynamicLabelValues('dynamic.cart.lbl_coupon_placeCash_Redemption');
    }
    return value?.replace('!', '');
  };

  const isPlacePerksCoupon = () => {
    return coupon?.offerType === COUPON_REDEMPTION_TYPE?.PLACEPERKS;
  };

  const isAutoApplyPerkCoupon = () => {
    const { originalOfferType = '', couponType = '' } = coupon;
    return (
      originalOfferType === COUPON_REDEMPTION_TYPE?.PERKSIMPLICIT ||
      (autoApplyPerkCouponType !== '' &&
        couponType &&
        autoApplyPerkCouponType?.includes(couponType))
    );
  };

  const renderAlwaysAppliedStatus = () => {
    return (
      <BodyCopy className="coupon_footer_wrapper">
        <BodyCopy
          data-locator={`coupon_${coupon?.status}_footer_expired`}
          className="couponCard_applied_footer_expired"
          component="div"
          fontSize="fs12"
          fontFamily="secondary"
          fontWeight="extrabold"
        >
          <Image alt="profile" className="link-icon" src={getIconPath('circle-check-green')} />{' '}
          {getDynamicLabelValues('dynamic.account_d.lbl_perk_status_always_applied')?.replace(
            '!',
            ''
          )}
        </BodyCopy>
      </BodyCopy>
    );
  };

  const getCouponVerifyCond = () => {
    return (
      !isCarouselView ||
      (isCarouselView && coupon?.status !== COUPON_STATUS?.APPLIED) ||
      (couponOnHoldNewDesign && coupon?.isOnHold === NewCouponCardConstant.TRUE)
    );
  };

  const getCouponFooterCond = ({ errorBonusPoints }) => {
    return (
      coupon?.isExpiring ||
      !coupon?.isStarted ||
      coupon?.isExpired ||
      (coupon?.isBPDBlackoutDay && !coupon?.usedBPD && isBonusPointDayEnabled) ||
      errorBonusPoints ||
      (couponOnHoldNewDesign && coupon?.isOnHold === NewCouponCardConstant.TRUE)
    );
  };

  const checkErrorBonusPoint = () => {
    const unavailableToday = coupon?.fromBonusPointsDay && coupon?.availableToday === 0;

    return (
      (coupon?.isApplied &&
        coupon?.fromBonusPointsDay &&
        coupon?.status === COUPON_STATUS?.AVAILABLE) ||
      unavailableToday
    );
  };

  const renderStatus = () => {
    const couponVerify = getCouponVerifyCond();

    if (isAutoApplyPerkCoupon()) {
      return renderAlwaysAppliedStatus();
    }

    function getTodayDate() {
      const today = new Date();
      const year = String(today?.getFullYear())?.slice(-2);
      const month = String(today?.getMonth() + 1)?.padStart(2, '0');
      const day = String(today?.getDate())?.padStart(2, '0');

      return `${month}/${day}/${year}`;
    }
    const currentDate = getTodayDate();
    const errorBonusPoints = checkErrorBonusPoint();

    return (
      (coupon?.error && (
        <BodyCopy className="coupon_footer_wrapper">
          <BodyCopy
            data-locator={`coupon_${coupon?.status}_footer_expired`}
            className="couponCard_error_footer_expired"
            component="div"
            fontFamily="secondary"
            fontWeight="extrabold"
          >
            {coupon?.offerType !== COUPON_REDEMPTION_TYPE?.PLACECASH ? (
              <>
                <Image
                  alt="profile"
                  className="link-icon"
                  src={getIconPath('icons-error-message')}
                />
                {coupon?.error}
              </>
            ) : (
              <ErrorMessage
                fontSize="fs11"
                fontWeight="extrabold"
                error={coupon?.error}
                icon="circle-info-red"
                noBackground={true}
                isEspot={coupon?.offerType === COUPON_REDEMPTION_TYPE?.PLACECASH}
              />
            )}
          </BodyCopy>
        </BodyCopy>
      )) ||
      (coupon?.isCouponApplicable === false && (spc || spcBag) && (
        <BodyCopy className="coupon_footer_wrapper">
          <BodyCopy
            data-locator={`coupon_${coupon?.status}_footer_expired`}
            className="couponCard_error_footer_expired"
            component="div"
            fontSize="fs12"
            fontFamily="secondary"
            fontWeight="extrabold"
          >
            <Image alt="profile" className="link-icon" src={getIconPath('circle-info-orange ')} />{' '}
            {coupon?.isCouponApplicable === false && coupon?.mobileCouponError}
          </BodyCopy>
        </BodyCopy>
      )) ||
      (getCouponFooterCond({
        coupon,
        isBonusPointDayEnabled,
        errorBonusPoints,
        couponOnHoldNewDesign,
      }) &&
        couponVerify && (
          <BodyCopy className="coupon_footer_wrapper">
            <BodyCopy
              data-locator={`coupon_${coupon?.status}_footer_expired`}
              className="couponCard__footer_expired"
              component="div"
              fontSize="fs12"
              fontFamily="secondary"
              fontWeight="extrabold"
            >
              <Image alt="profile" className="link-icon" src={getIconPath('circle-info-orange')} />{' '}
              {coupon?.isBPDBlackoutDay && isBonusPointDayEnabled
                ? `${renderLabel(
                    accountLabel.accountOverview?.lbl_bonus_points_black_out_day_warning,
                    'lbl_bonus_points_black_out_day_warning'
                  )} ${currentDate}`
                : getCouponExpiringStatus()}
            </BodyCopy>
          </BodyCopy>
        )) ||
      (isCarouselView && coupon?.status === COUPON_STATUS?.APPLIED && (
        <BodyCopy className="coupon_footer_wrapper">
          <BodyCopy
            data-locator={`coupon_${coupon?.status}_footer_expired`}
            className="couponCard_applied_footer_expired"
            component="div"
            fontSize="fs12"
            fontFamily="secondary"
            fontWeight="extrabold"
          >
            <Image alt="profile" className="link-icon" src={getIconPath('circle-check-green')} />{' '}
            {renderLabel(
              globalLabels.placeRewards?.lbl_my_rewards_applied,
              'lbl_my_rewards_applied'
            )
              ?.toLowerCase()
              ?.replace('!', '')}
          </BodyCopy>
        </BodyCopy>
      ))
    );
  };
  const RenderIcon = () => {
    let couponIcon;
    if (coupon?.offerType === COUPON_REDEMPTION_TYPE?.PLACECASH) couponIcon = 'place-bucks';
    else if (coupon?.offerType === COUPON_REDEMPTION_TYPE?.REWARDS) couponIcon = 'rewards';
    else if (coupon?.offerType === COUPON_REDEMPTION_TYPE?.BENEFITS) couponIcon = 'superstar';
    else couponIcon = 'dollar-icon';
    return (
      <div className="coupon-icon-wrapper">
        <Image alt="profile" className="coupon-icon" src={getIconPath(couponIcon)} />
      </div>
    );
  };

  const checkApplyCTADisabled = () => {
    return (
      isFetching ||
      coupon?.isBPDBlackoutDay ||
      (coupon?.isApplied && coupon?.fromBonusPointsDay && isBonusPointDayEnabled) ||
      (coupon?.fromBonusPointsDay && coupon?.availableToday === 0) ||
      multiAddCouponLoader
    );
  };

  const RenderApplyButton = (globalActionLabels) => {
    const hideButtonClassName =
      isPlacePerksCoupon() && isAutoApplyPerkCoupon() ? 'hide-button' : '';
    const isApplying = coupon?.labelStatus === NewCouponCardConstant.APPLYING;
    return (
      <Button
        loading={isApplying}
        onClick={() => {
          setTimeout(() => {
            onApply({ coupon });
            fromIsApplyAction(true);
            if (isBonusPointDayEnabled && coupon?.fromBonusPointsDay) {
              setBonusPointDayCouponIndexAction(coupon?.couponIndex);
            }
          }, 0);
        }}
        className={
          isAccountDrawer || (isPlacePerkEnabled && isPlacePerks)
            ? `coupon__button_white ${hideButtonClassName}`
            : `coupon__button_black ${hideButtonClassName}`
        }
        buttonVariation="variable-width"
        type="submit"
        data-locator={`coupon_${coupon.status}_apply_cartCta`}
        fullWidth="true"
        disabled={checkApplyCTADisabled()}
        aria-labelledby={coupon?.id}
      >
        {!isApplying && renderLabel(globalActionLabels.lbl_apply, 'lbl_apply')}
      </Button>
    );
  };

  const RenderRemoveButton = (globalActionLabels) => {
    const isRemoving = coupon?.labelStatus === NewCouponCardConstant.REMOVING;
    return (
      <Button
        loading={isRemoving}
        onClick={(e) => {
          e.preventDefault();
          onRemove({ coupon });
          fromIsApplyAction(true);
        }}
        className="coupon__button_white"
        buttonVariation="variable-width"
        type="submit"
        data-locator={`coupon_${coupon?.status}_remove_cartCta`}
        fullWidth="true"
        aria-label={`${coupon?.labelStatus} ${coupon?.id}`}
      >
        {!isRemoving && renderLabel(globalActionLabels.lbl_remove, 'lbl_remove')}
      </Button>
    );
  };

  const RenderValidText = () => {
    return (
      <BodyCopy
        className="couponCard__text_style"
        component="p"
        fontSize="fs10"
        data-locator={`coupon_${coupon?.status}_cartValidValidity`}
        fontFamily="secondary"
      >
        {`Valid ${coupon?.effectiveDate} - ${coupon?.expirationDate}`}
      </BodyCopy>
    );
  };

  const RenderUseByText = () => {
    return (
      <BodyCopy
        className="couponCard__text_style"
        data-locator={`coupon_${coupon?.status}_cartUseByValidity`}
        component="p"
        fontSize="fs10"
        fontFamily="secondary"
      >
        {`${renderLabel(checkoutLabels.bagPage?.lbl_coupon_validThru, 'lbl_coupon_validThru')} ${
          coupon?.expirationDate
        }`}
      </BodyCopy>
    );
  };

  const RenderButtons = () => {
    const globalActionLabels =
      getLabelFromCopyOrFromTranslation(GLOBAL_ACTIONS_LABELS, GlobalActionsLabels) || {};
    return (
      <div>
        {coupon?.isOnHold !== NewCouponCardConstant.TRUE &&
          coupon?.status === COUPON_STATUS?.AVAILABLE &&
          coupon?.isStarted &&
          !(coupon?.isExpired && coupon?.status === COUPON_STATUS?.APPLIED) &&
          RenderApplyButton(globalActionLabels)}
        {coupon?.isOnHold !== NewCouponCardConstant.TRUE &&
          coupon?.status === COUPON_STATUS?.APPLIED &&
          !coupon?.isExpired &&
          RenderRemoveButton(globalActionLabels)}
        {(coupon?.isOnHold === NewCouponCardConstant.TRUE ||
          (coupon?.isExpired && coupon?.status === COUPON_STATUS?.APPLIED)) &&
          RenderRemoveButton(globalActionLabels)}
      </div>
    );
  };

  const handleDefaultLinkClick = (event) => {
    event.preventDefault();
    setTimeout(() => {
      couponDetailClick(coupon);
    }, 0);
  };

  const errorNotification = () => {
    return (
      <>
        {couponsOnHold && (
          <Notification
            className="max-qty-reached elem-mt-MED"
            status="warning"
            isErrorTriangleIcon
            message={
              coupon?.originalOfferType === NewCouponCardConstant.PLCB
                ? renderLabel(
                    checkoutLabels.bagPage?.lbl_coupon_onhold_error,
                    'lbl_coupon_onhold_error'
                  )
                : renderLabel(
                    checkoutLabels.bagPage?.lbl_coupon_apple_onhold_error,
                    'lbl_coupon_apple_onhold_error'
                  )
            }
          />
        )}
      </>
    );
  };

  const verifySpcCheckCoupons = () => {
    return !isCarouselView && !spc;
  };

  return (
    <div className={`${className} new-coupon-wrapper`}>
      <div className="new-coupon-container">
        {RenderIcon()}
        <div className="new-coupon-info-container">
          <div className="infoSection">
            <p className="coupon-title">{`${coupon?.title}`}</p>
            <div className="sub-section">
              {coupon?.offerType === COUPON_REDEMPTION_TYPE?.SAVING && RenderUseByText()}
              {coupon?.offerType === COUPON_REDEMPTION_TYPE?.REWARDS && RenderUseByText()}
              {coupon?.offerType === COUPON_REDEMPTION_TYPE?.PLACECASH && RenderValidText()}
              {coupon?.offerType === COUPON_REDEMPTION_TYPE?.BENEFITS && RenderUseByText()}
              <Button
                dataLocator={`coupon_${coupon?.status}_cartDetailsLink`}
                fontSizeVariation="small"
                underline
                anchorVariation="primary"
                nohover
                type="button"
                link
                onClick={handleDefaultLinkClick}
                className="cartDetailsLink"
                aria-label={`${coupon?.id} ${renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
                    GlobalGenericLabels
                  ),
                  'lbl_details'
                )}`}
              >
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
                    GlobalGenericLabels
                  ),
                  'lbl_details'
                )}
              </Button>
            </div>
          </div>
          {!coupon?.usedBPD && RenderButtons()}
        </div>
      </div>
      <div className="coupon-status">
        {errorNotification()}
        {verifySpcCheckCoupons() && (
          <ErrorMessage
            fontSize="fs12"
            fontWeight="extrabold"
            error={coupon?.error}
            icon="circle-info-red"
            noBackground={spcBag}
            isEspot={coupon?.offerType === COUPON_REDEMPTION_TYPE?.PLACECASH}
          />
        )}
        {(isAccountDrawer ||
          (isPlacePerkEnabled && isPlacePerks) ||
          (isPlacePerksCoupon() && isAutoApplyPerkCoupon())) &&
          renderStatus()}
      </div>
    </div>
  );
};
NewCouponCard.defaultProps = {
  couponsOnHold: false,
  spc: false,
  spcBag: false,
  isAccountDrawer: false,
  isPlacePerkEnabled: false,
  isPlacePerks: false,
  autoApplyPerkCouponType: '',
};

NewCouponCard.propTypes = {
  coupon: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  handleErrorCoupon: PropTypes.func.isRequired,
  commonLabels: PropTypes.shape({}).isRequired,
  onApply: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  couponDetailClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  couponsOnHold: PropTypes.bool,
  spc: PropTypes.bool,
  spcBag: PropTypes.bool,
  isAccountDrawer: PropTypes.bool,
  isPlacePerkEnabled: PropTypes.bool,
  isPlacePerks: PropTypes.bool,
  autoApplyPerkCouponType: PropTypes.string,
  ledgerSummaryData: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  isBonusPointDayEnabled: PropTypes.bool.isRequired,
  setBonusPointDayCouponIndexAction: PropTypes.func.isRequired,
  fromIsApplyAction: PropTypes.func.isRequired,
  multiAddCouponLoader: PropTypes.bool.isRequired,
  isCarouselView: PropTypes.bool.isRequired,
  couponOnHoldNewDesign: PropTypes.bool.isRequired,
};
export default withStyles(NewCouponCard, styles);
export { NewCouponCard as NewCouponCardVanilla };
